import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Flash, Spinner } from '@primer/react';
import styled from 'styled-components';
import { FUNCTION_TYPE } from '../../utils/constants.js';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var FlashContent = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n"], ["\n  align-items: center;\n  display: flex;\n"])));
var LTFlash = function LTFlash(_a) {
  var _b = _a.crossIcon,
    crossIcon = _b === void 0 ? "" : _b,
    _c = _a.extraStyles,
    extraStyles = _c === void 0 ? {} : _c,
    handleClose = _a.handleClose,
    _d = _a.iconComponent,
    iconComponent = _d === void 0 ? null : _d,
    _e = _a.loading,
    loading = _e === void 0 ? false : _e,
    secondaryAction = _a.secondaryAction,
    _f = _a.tabIndex,
    tabIndex = _f === void 0 ? "0" : _f,
    _g = _a.text,
    text = _g === void 0 ? "" : _g,
    _h = _a.variant,
    variant = _h === void 0 ? LTFlash.Variants.DEFAULT : _h;
  var Styles = {
    alignItems: "center",
    borderRadius: "0px",
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    color: "#24292F",
    display: "flex",
    fontSize: "14px",
    height: "48px",
    justifyContent: "space-between"
  };
  return /*#__PURE__*/React.createElement(Flash, {
    sx: __assign(__assign(__assign({}, Styles), extraStyles), variant === LTFlash.Variants.DEFAULT && {
      borderColor: "flashDefault.muted",
      background: "lightBlueAccent.subtle"
    }),
    variant: variant,
    role: "alert"
  }, /*#__PURE__*/React.createElement(FlashContent, null, iconComponent, !!loading && /*#__PURE__*/React.createElement(Spinner, {
    size: "small"
  }), text), /*#__PURE__*/React.createElement("div", null, secondaryAction && secondaryAction, !!(handleClose && _typeof(handleClose) === FUNCTION_TYPE) && /*#__PURE__*/React.createElement("img", {
    className: "cursor-pointer",
    onClick: handleClose,
    src: crossIcon,
    tabIndex: tabIndex,
    alt: "crossIcon",
    role: "button"
  })));
};
// Define Variants as a static property on LTFlash
LTFlash.Variants = {
  DANGER: "danger",
  DEFAULT: "default",
  SUCCESS: "success",
  WARNING: "warning"
};
var templateObject_1;

export { LTFlash as default };
